<template>
  <div class="first-change-password">
    <div class="content">
      <div class="title">修改密码 <span class="title-red">（首次登录需修改密码，密码修改成功后，自动进入系统）</span></div>
      <div class="form">
        <el-form ref="changePwdForm" class="change-password-form" :rules="changePwdRules" :model="changePwdForm"
                 label-width="110px" label-position="left">
          <el-form-item label="请输入新密码" prop="changePwd">
            <el-row>
              <el-col :span="11">
                <el-input v-focus type="password" @input="checkStrength" v-model="changePwdForm.changePwd" @keydown.enter.native="changePwd" placeholder="请输入新密码"></el-input>
              </el-col>
              <el-col :span="12">
                <div class="strength-check">
                  <el-row>
                    <el-col :span="8">
                      <div class="level-block">
                        <div class="level-img" :class="level>=1?'red':''">弱</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="level-block">
                        <div class="level-img" :class="level>=2?'red':''">中</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="level-block">
                        <div class="level-img" :class="level>=3?'red':''">强</div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="请确认新密码" prop="confirmPwd">
            <el-input type="password" v-model="changePwdForm.confirmPwd" @keydown.enter.native="changePwd" placeholder="请确认新密码"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="hint"><i class="el-icon-warning"></i>密码长度为6~16个字符，至少包含数字/字母/字符任意2种组合</div>
          </el-form-item>
          <div class="button-block">
            <el-button type="primary" @click="changePwd">确认修改</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'firstChangePassword',
  data () {
    let confirmPwdRules = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请确认新密码'))
      } else if (value !== this.changePwdForm.changePwd) {
        callback(new Error('两次输入密码不一致!'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('新密码不符合密码规则'))
      } else if (reg.test(value) === false) {
        callback(new Error('新密码不符合密码规则'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    let changePwdRules = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('新密码不符合密码规则'))
      } else if (reg.test(value) === false) {
        callback(new Error('新密码不符合密码规则'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    let oldPwd = this.$route.query.pwd
    return {
      level: 0,
      canSubmit: true,
      changePwdForm: {
        oldPwd,
        changePwd: '',
        confirmPwd: ''
      },
      changePwdRules: {
        changePwd: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        },
        {
          validator: changePwdRules,
          trigger: 'change'
        },
        {
          validator: changePwdRules,
          trigger: 'blur'
        }
        ],
        confirmPwd: [{
          required: true,
          message: '请确认新密码',
          trigger: 'blur'
        },
        {
          validator: confirmPwdRules,
          trigger: 'change'
        },
        {
          validator: confirmPwdRules,
          trigger: 'blur'
        }
        ]
      }
    }
  },
  methods: {
    checkStrength () {
      let reg1 = /\W/
      let reg2 = /[A-Za-z]/
      let reg3 = /[0-9]/
      this.level = 0
      if (reg1.test(this.changePwdForm.changePwd)) {
        // 密码等级增加
        this.level++
      }
      if (reg2.test(this.changePwdForm.changePwd)) {
        this.level++
      }
      if (reg3.test(this.changePwdForm.changePwd)) {
        this.level++
      }
    },
    changePwd () {
      let _this = this
      this.$refs.changePwdForm.validate(valid => {
        if (valid) {
          this.$axios.post('/auth-api/login/auth/changePassword', {
            oldPw: _this.changePwdForm.oldPwd,
            newPw: _this.changePwdForm.confirmPwd
          })
            .then((res) => {
              _this.$message.success('修改成功')
              _this.$emit('hasMenu', true)
              let laterFunc = ''
              clearTimeout(laterFunc)
              laterFunc = setTimeout(function () {
                _this.$router.replace({
                  name: 'index'
                })
              }, 3000)
            })
        }
      })
    }
  }
}

</script>

<style lang="scss">
  .first-change-password {
    width: 100%;
    height: 100%;
    background-color: #F8FBFE;
    padding-top: 182px;
    & > .content {
      width: 916px;
      margin: 0 auto;
      height: 274px;
      background-color: #fff;
      box-shadow: 3px 1px 8px 0 rgba(184,222,253,0.2);
      border-radius: 4px;
      .title {
        font-size: 14px;
        font-family :Microsoft YaHei;
        font-weight :400;
        color: #232323;
        padding: 13px 0 13px 20px;
        border-bottom: 1px solid #EDEEEE;
        .title-red {
          color: #FC3232;
          font-size: 10px;
        }
      }
      & > .form {
        padding: 35px 0 0 176px;
        & > .change-password-form {
          .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
            display: none;
          }
          .el-form-item {
            span, label {
              font-size: 12px;
            }
            .el-input {
              width: 266px;
              .el-input__inner {
                width: 266px;
                height: 30px;
                border: 1px solid #c2c3c4;
                border-radius: 4px;
              }
            }
            .hint {
              font-size: 10px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(128,128,128,1);
              line-height: 9px;
              padding-bottom: 13px;
              .el-icon-warning {
                color: #659FF0;
                margin-right: 8px;
              }
            }
            .strength-check {
              width: 170px;
              height: 30px;
              line-height: 30px;
              .el-row {
                height: 30px;
                padding-top: 4.5px;
                .level-img {
                  font-size: 10px;
                  text-align: center;
                  border-radius: 4px;
                  height: 18px;
                  line-height: 18px;
                  width: 52px;
                  margin-right: 7px;
                  background-color: #f2f1ef;
                }

                .red {
                  background-color: #fb615e;
                  color: #fff;
                }
              }
            }
          }
          .button-block {
            padding-left: 179px;
            .el-button {
              padding: 0;
              width: 72px;
              height: 26px;
              background: #54ABF1;
              border-radius: 4px;
              border-color: #54ABF1;
              &:hover, &:active, &:focus {
                background: #54ABF1;
                border-color: #54ABF1;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/first-change-password.vue